import React from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import Dashboard from "./components/Dashboard";
import ThemeToggle from "./components/ThemeToggle";
import "./App.css";
import "./styles/CategoryDetail.css";
import "./styles/BrandDetail.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Header from "./components/Header";
import AnalyticsDashboard from "./components/AnalyticsDashboard/AnalyticsDashboard";
import AllBrandsPage from "./components/AnalyticsDashboard/AllBrandsPage";
import Login from "./components/AnalyticsDashboard/Login";
import ProtectedRoute from "./ProtectedRoute ";
import NotFound from "./components/AnalyticsDashboard/NotFound";
import AdvancedMetrics from "./components/AnalyticsDashboard/AdvancedMetrics";
import ManageAccessList from "./components/AnalyticsDashboard/ManageAccessList";
import DataDisplay from "./components/AnalyticsDashboard/DataDisplay";
import UsageStats from "./components/UsageStats";
import RAGManagement from "./components/RAGManagement/RAGManagement";

const AppContent = () => {
  const location = useLocation();
   const navigate = useNavigate();
  const knownPaths = ["/", "/healthdashboard", "/dataAnalytics", "/allBrands", "/rag-management"];
  const isKnownPath = knownPaths.includes(location.pathname);

  const shouldShowHeader =
    location.pathname !== "/" &&
    location.pathname !== "/allBrands" &&
    location.pathname !== "/rag-management" &&
    isKnownPath;

  const shouldShowThemeToggle =
    !["/", "/dataAnalytics", "/allBrands", "/rag-management"].includes(location.pathname) &&
    isKnownPath;

  return (
    <div className="App">
      {shouldShowHeader && <Header />}
      <Routes>
        <Route
          path="/"
          element={
            localStorage.getItem("user_name") ? (
              <Navigate to="/dataAnalytics" />
            ) : (
              <Login />
            )
          }
        />{" "}
        <Route
          path="/healthdashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dataAnalytics"
          element={
            <ProtectedRoute>
              <AnalyticsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/allBrands"
          element={
            <ProtectedRoute>
              {/* <AllBrandsPage /> */}
              <DataDisplay />
            </ProtectedRoute>
          }
        />
        <Route
          path="/advanced-metrics"
          element={
            <ProtectedRoute>
              <AdvancedMetrics onBack={() => navigate(-1)} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-access-list"
          element={
            <ProtectedRoute>
              <ManageAccessList onBack={() => navigate(-1)} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usage-stats"
          element={
            <ProtectedRoute>
              <UsageStats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rag-management"
          element={
            <ProtectedRoute>
              <RAGManagement />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>



      {shouldShowThemeToggle && <ThemeToggle />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
